import React, { Component } from 'react';


import ModernCalendar from '../../Home/Mobile/Calendar/Calendar';
import TimeSlider from '../../Duties/Mobile/TimeSlider/TimeSlider';
import Suggest from './Suggest/Suggest';
import Repeat from '../../Duties/Mobile/Repeat/Repeat';
import MapSelector from '../../Event/Mobile/MapSelector/MapSelector';
import ColorRadio from '../../Duties/Mobile/ColorRadio/ColorRadio';
import Note from '../../Duties/Mobile/Note/Note';

import calendar from '../../../assets/icons/calendar.svg';
import clock from '../../../assets/icons/clock.svg';


import '../../Duties/Mobile/Duties.css';

export default class Reminder extends Component {

  render() {
    const { defaultLocation,
      zoom,
      location,
      float,
      tag,
      title,
      orders,
      repeat,
      repeats,
      selectedDay,
      selectedAlarm,
      selectedColor,
      selectedRepeat,
      note,
      colors,
      openCalendar,
      setOpenCalendar,
      openEvents,
      openFloat,
      openRepeat,
      closeFloat,
      closeRepeat,
      setSelectedDay,
      setColor,
      fillTitle,
      setTag,
      deleteTag,
      handleChangeLocation,
      handleChangeZoom, } = this.props;
    return (
      <div className="mobile-duties d-flex flex-column">
        <div className="mobile-duties__header d-flex">
          <h1>یادآوری</h1>
          <button className="btn">ذخیره</button>
        </div>
        <Suggest
          float={float}
          openFloat={openFloat}
          tag={tag}
          title={title}
          closeFloat={closeFloat}
          fillTitle={fillTitle}
          orders={orders}
          setTag={setTag}
          deleteTag={deleteTag}
          name={'یادآوری'} />
        <div className="mobile-duties__features flex-wrap d-flex">
          <div className="mobile-duties__features--item">
            <h2>تاریخ و زمان</h2>
            <div className="mobile-float-input d-flex">
              <img src={calendar} className="mic" />
              <div className="mobile-float-input__value" onClick={() => setOpenCalendar()}>
                {selectedDay ? selectedDay : 'انتخاب'}
              </div>
            </div>
          </div>
          <Repeat
            closeRepeat={closeRepeat}
            openRepeat={openRepeat}
            selectedRepeat={selectedRepeat}
            repeat={repeat}
            repeats={repeats}
          />
        </div>

        <ColorRadio colors={colors} setColor={setColor} />
        <Note />

        <MapSelector
          defaultLocation={defaultLocation}
          zoom={zoom}
          handleChangeLocation={handleChangeLocation}
          handleChangeZoom={handleChangeZoom}
        />
        {
          openCalendar ?
            <div className="mobile-duty-calendar">
              <div className="mobile-duty-calendar__top" onClick={() => setOpenCalendar()}></div>
              <div className="mobile-duty-calendar__bottom">
                <ModernCalendar selectedDay={selectedDay} setSelectedDay={setSelectedDay} />
                <div className="mobile-duty-time d-flex flex-column">
                  <div className="d-flex">
                    <img src={clock} className="ml-3" />
                    <h3>ساعت وظیفه را انتخاب نمایید</h3>
                  </div>
                  <TimeSlider />
                  <button className="mobile-duty-calendar__bottom--button" onClick={() => setOpenCalendar()}>ثبت</button>
                </div>
              </div>
            </div> : null
        }
      </div>
    );
  }
}
